




















































import Vue, { PropType } from 'vue'
import { PagerMeta } from '@/core/Programs'
import { Location } from 'vue-router'

export default Vue.extend({
  components: {},
  props: {
    meta: {
      type: Object as PropType<PagerMeta>,
      required: true,
    },
  },
  computed: {
    searchQuery(): Location['query'] {
      // NOTE: スプレッド構文にしないと$routeを書き換えようとしてNavigationDuplicatedになる
      const query = { ...this.$route.query }
      delete query.page
      return query
    },
    firstPage(): Location {
      return this.getLocation(1)
    },
    lastPage(): Location {
      return this.getLocation(this.meta.lastPage)
    },
    prevPage(): Location {
      return this.getLocation(this.meta.currentPage - 1)
    },
    nextPage(): Location {
      return this.getLocation(this.meta.currentPage + 1)
    },
    currentPage(): Location {
      return this.getLocation(this.meta.currentPage)
    },
  },
  methods: {
    getLocation(page: number): Location {
      if (page === 1) {
        return { query: this.searchQuery }
      }
      return { query: { ...this.searchQuery, page: String(page) } }
    },
  },
})
